// extracted by mini-css-extract-plugin
export default {"base":"styles__base__u2JmK"};